import type { QueryStatus } from '@tanstack/react-query'
import { useRouter } from 'next/router'

import { useSnackbarRestStatus } from '../../../hooks'

export const SnackbarFromQuery = () => {
  const router = useRouter()

  useSnackbarRestStatus({
    status: router?.query.status as QueryStatus,
    messages: {
      success: router?.query.message as string,
      defaultError: router?.query.message as string,
    },
  })
  return null
}
